import ProgrammeImage2 from "../../../../../assets/images/png/courses/programme2.webp";
import SchoolImage from "../../../../../assets/images/png/school/design-school.webp";

export const designSchoolDataAfrica = {
  tag: "Design",
  id: "designSchool",
  url: "/design-school",
  image: SchoolImage,

  name: "Design School",
  description: `Our Instructor-led and hands-on training model helps you learn a combination of the art and
  science of tech product design with an emphasis on solving business cases.`,
  keywords: `product design, product design training, product designer, UI/UX designer, design school`,
  metatags: `UI/UX design training in Nigeria. Become a highly sought after product designer. Learn how to build digital products for companies and startups.`,
  courses: [
    {
      id: 1,
      courseImage: ProgrammeImage2,
      courseName: "Design Bootcamp",
      courseDescription: `
      This design learning program is taught by tech leaders and created as project-based learning
      to help you develop the skills to create user experiences for products or digital properties.

    `,
      courseStartDate: "December 2, 2023",

      courseDuration: "6 Weeks",

      courseTags: ["For Starters"],

      courseUrl: "/design-bootcamp",

      enrolUrl: "https://flutterwave.com/pay/utiva-design-payment",
    },
  ],

  testimony: {
    // testimonierImage: `https://res.cloudinary.com/codeg0d/image/upload/v1624419471/abdullah_pw40f0.jpg`,
    testimonierName: "Olaniyi Abdullah",
    testimonierTitle: "Design School",
    testimonyDescription: `It was an  amazing learning experience at Utiva on Product Designing which centers around design thinking, empathy maps, information architecture, and prototyping. Utiva took us through an experiential learning approach towards becoming a top class Product Designer.`,
  },

  article: [],

  careerTitle: "Product Designer",

  careerPaths: [
    "UI Designer",
    "UX Reseacher",
    "Design Lead",
    "Product Designer",
    "VP Product",
    "Chief Product Officer",
  ],

  quickFactSalary: "$99,273",

  quickFacts: [
    "Product Design has been identified as one of the skills for the future of work, according to a 2021 report by the World Economic Forum.",
  ],
};
